type AmpImageProps = {
  alt?: string
  className?: string
  height?: string | number
  layout?: string
  src: string
  style?: import("react").CSSProperties
  width: string | number
  title?: string
}

export function AmpImage(props: AmpImageProps) {
  const {
    alt,
    title,
    className,
    height = "1",
    layout = "responsive",
    src,
    style,
    width,
  } = props

  return (
    <amp-img
      alt={alt}
      title={title}
      className={className}
      src={src}
      height={height}
      width={width}
      layout={layout}
      style={style}
    />
  )
}
